import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Review 2",
    id: "4WB-R2-P49-E5",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page29/Key/E1answerKey.png",
    component: Circle_Write,
    // checkUppercase: true,
    isHiddenCheck: true,
   

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Các em Bấm chuột vào chữ A,B,C để chọn câu trả lời </span>
        <video style="width: 100%; height: 2cm" src="/Audios/guide/p29_e1.mp3" controls></video>
        `,
      },
    ],
    titleQuestion: [
      {
        title: `
        <div><img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-30px "/> </div>
				`,
        color: "rgb(28, 192, 217)",
      },
    ],

    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 10,
        inputStyle: {
          width: 250,
          fontSize: 24,
          textAlign: "center",
          height: 29,
          paddingBottom: 10,
          textTransform: "uppercase",
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 5,
          // borderColor: "transparent",
          fontWeight: 700,
          color: "rgb(88,147,198)",
        },
        // initialWordStyle: { fontWeight: 'bold', border: 'none', borderRadius: '50%', borderColor: 'transparent' },
        selectWordStyle: {
          padding: 5,
          border: "2px solid black",
          borderRadius: "50%",
          // borderColor: "",
        },
        limitSelect: 1,
        listWords: [`A <br> B <br> C <br> D`],
        answers: ["0-0"],
        initialValue: [],
      },
      Layout: `
      <div style='display:flex'>
      	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:95px;height:50px;margin-right:10px;margin-top:-10px'>
      	  <b>1</b>
      	</div>
        Mỗi chiếc quạt xòe ra tạo thành một góc. Bạn Nga đếm số góc nhọn, góc vuông, góc tù và góc bẹt rồi tạo một biểu đồ như hình vẽ. Nhưng bạn ấy bị nhầm cột, hỏi cột đó là cột nào?
      </div> 
      <div style='position: relative; margin-top: 30px'>

      <img src='img/FriendsPlus/Page29/E1/1.jpg' style='width: 19cm; height: 10cm; margin-left: 150px; margin-bottom: 30px'><br>
      <b>Bạn Nga kiểm đếm nhầm ở cột:</b> 
      <div style='display: flex; gap: 15px;'>
                <div><input id='0' type='Circle' /></div>
                <div>
                  <div>Góc nhọn</div>
                  <div>Góc vuông</div>
                  <div>Góc tù</div>
                  <div>Góc bẹt</div>
                </div>

        
	    </div>
      `,
    },
  },
  2: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E1",
    audio: "",
    video: "",
    isHiddenCheck:true,
    // protractor: true,
    // isHello:false,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page29/Key/E2answerKey.png",
    component: T6,
    inputSize: 70,
    maxLength: 3,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "2px dotted gray",
      fontSize: "24px",
      textAlign: "center",
    },
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>
        
    //     `,
    //   },
    // ],

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Điền câu trả lời vào ô trống.</span>
        <video style="width: 100%; height: 2cm" src="/Audios/guide/p29_e2.mp3" controls></video>
        `,
      },
    ],
    titleQuestion: [
      {
        title: `
        <div><img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-30px "/> </div>
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex; align-items: center;'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>2</b>
        	</div>
          <span style='padding: 0px 10px 0px 10px; background-color: rgb(255,214,0); border-radius: 10px; '> Số </span> &ensp;?
        </div> <br>
        <img src='img/FriendsPlus/Page29/E2/1.png' style='width: 22cm; height: 9cm;margin-top:-90px'  />
				<div>
        Hình bên có <span style='padding: 5px 10px 5px 10px; border: 2px solid rgb(255,214,0); border-radius: 10px;'><input id='0'></span> góc nhọn, 
        <span style='padding: 5px 10px 5px 10px; border: 2px solid rgb(255,214,0); border-radius: 10px;'><input id='1'></span> góc vuông, 
        <span style='padding: 5px 10px 5px 10px; border: 2px solid rgb(255,214,0); border-radius: 10px;'><input id='2'></span> góc tù. 
        </div>
				
				</div>
				
        `,
        answer: ["4", "2", "1"],
      },
    ],
  },
  3: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E1",
    audio: "",
    video: "",
    // protractor: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page29/Key/E1answerKey.jpg",
    component: T6,
    inputSize: 70,
    maxLength: 3,
    // hideBtnFooter: true,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "2px dotted gray",
      fontSize: "24px",
      textAlign: "center",
    },
    guideModal: [
      {
        title: "Hướng dẫn trò chơi",
        description: `
        <p>
        <span style="font-weight: bold">Cách chơi: </span>
        <span>Chơi theo cặp đôi hoặc đội chơi. Đội xanh xuất phát ở ô có hình trứng khủng long màu xanh. Đội vàng xuất phát ở ô có hình trứng khủng long màu vàng</span>
      </p>
        <p>
          <span style="font-weight: bold">Đội đi trước: Đội Xanh</span>
        </p>
        <p>
          <span style="font-weight: bold">Quay xúc sắc: </span>
          <span>Nháy chuột vào nút Đội xanh để quay. 
          Nếu số chấm trên mặt xúc sắc là số lẻ thì ô vuông của mỗi đội tự động tiến 1 ô. Số chẵn thì tiến 2 ô. Ô vuông dừng lại ở ô nào thì người chơi xác định góc được tạo bởi kim giờ và kim phút của đồng hồ rồi tích vào mục Chọn đáp án để lựa chọn "góc nhọn", "góc vuông", "góc tù" hay "góc bẹt". Sau đó bấm xác nhận.
          </span>
        </p>

        <p>
        <span style="font-weight: bold">Trò chơi kết thúc: </span>
        <span>Trò chơi kết thúc khi có một người chơi đến được một trong hai ô màu xanh </span>
      </p>
        
        <audio src="/Audios/huong dan tro choi.mp3" controls></audio>

        
        `,
      },
    ],
    dice: [
      {
        team1DefaultPosition: {
          // vị trí ô bắt đầu của team 1
          top: "206px",
          left: "398px",
        },
        team2DefaultPosition: {
          // vị trí ô bắt đầu của team 2
          top: "480px",
          left: "14px",
        },
        borderTeam1Position: [
          {
            top: "114px",
            left: "398px",
          },
          {
            top: "23px",
            left: "398px",
          },
          {
            top: "23px",
            left: "301px",
          },
          {
            top: "23px",
            left: "205px",
          },
          {
            top: "117px",
            left: "205px",
          },
          {
            top: "117px",
            left: "108px",
          },
          {
            top: "117px",
            left: "11px",
          },
          {
            top: "208px",
            left: "11px",
          },
          {
            top: "297px",
            left: "11px",
          },
          {
            top: "297px",
            left: "109px",
          },
        ],
        borderTeam2Position: [
          {
            top: "572px",
            left: "14px",
          },
          {
            top: "572px",
            left: "112px",
          },
          {
            top: "572px",
            left: "208px",
          },
          {
            top: "572px",
            left: "305px",
          },
          {
            top: "572px",
            left: "400px",
          },
          {
            top: "479px",
            left: "400px",
          },
          {
            top: "389px",
            left: "400px",
          },
          {
            top: "389px",
            left: "304px",
          },
          {
            top: "389px",
            left: "208px",
          },
          {
            top: "298px",
            left: "208px",
          },
        ],
        team1Answers: [4, 2, 2, 1, 1, 3, 1, 3, 1, 3],
        team2Answers: [3, 3, 3, 1, 1, 1, 1, 3, 3, 3],
      },
    ],
    titleQuestion: [
      {
        title: `
        <div><img src="img/FriendsPlus/Page29/b.jpg" style="height:30mm;margin-left:-70px;margin-top:-30px "/> </div>
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style="display: flex;row-gap: 20px;">
        <img src="/img/FriendsPlus/page29/6.jpg" style="width: 516px;"  alt="image" />
          <div style="display: flex;flex-direction: column;align-items: center;margin-top: 20px;margin-left: 35px;">
              <img
                id='dice-image'
                src="/img/FriendsPlus/page29/E3/dice-0.png"
                alt="image"
                style="width: 110px;"
              />
            
          
            <button
              id="button-xuc-sac"
              style="
                outline: none;
                background-color: rgb(41, 128, 185);
                border: none;
                color: white;
                padding: 10px 20px;
                border-radius: 5px;
                margin-top: 10px;
                cursor: pointer;
                width:130px;
                font-size: 20px;

              "
            >
            Đội xanh
            </button>

            <button
              id="button-choi-lai"
              style="
                outline: none;
                background-color: rgb(0, 206, 201);
                border: none;
                color: white;
                padding: 10px 20px;
                border-radius: 5px;
                margin-top: 10px;
                cursor: pointer;
                width:130px;
                font-size: 20px;
                display:none

              "
            >
            Chơi lại
            </button>
          </div>
          <div>
          
        </div>
          
        </div>
        <div id='border-team1' class ='dice-border dice-border-linear' style="width: 100px;  position: absolute;top: 206px;left: 398px;">
        </div>

        <div id='border-team2' class ='dice-border dice-border-linear2' style="width: 100px;  position: absolute;top: 480px;left: 14px;">
        </div>
    
        `,
        answer: ["", "", ""],
      },
    ],
  },
};

export default json;
